export const maxLengthMessage = (field: string, max: number) =>
    `${field} cannot exceed ${max} characters`;

export const nameConstraintsMessage = (field: string) =>
    `${field} can only contain letters, spaces, hyphens and apostrophes, and must start and end with a letter`;
